/**
 * Upsell integration for cart drawer add-to-cart flow.
 *
 * The cart drawer (sectionhunt-cart-drawer.liquid:2292) registers a capture-phase
 * click handler on each ATC button. It calls e.preventDefault(), reads the variant
 * from the form, and calls cartApp.addToCart(variantId) with the main product only.
 *
 * This script registers a DOCUMENT-level capture handler. In the DOM capture phase,
 * events flow from document down to the target, so this fires BEFORE the button-level
 * handler. When upsell data is present, it:
 *  - Stops propagation (prevents the cart drawer's handler from running)
 *  - Prevents default (prevents form submission)
 *  - Shows a spinner on the button
 *  - POSTs main product + upsells to /cart/add.js
 *  - Waits for the response, then opens/refreshes the cart drawer
 *  - Dispatches cart:change for the header cart count
 *
 * When no upsell data is present, the event propagates normally and the cart
 * drawer handles it as before. No Vue proxy mutation needed.
 */
(function () {
  'use strict';

  var ATC_SELECTOR = '[name="add"], .product-form__submit, button[type="submit"][name="add"]';

  document.addEventListener('click', function (e) {
    var button = e.target.closest(ATC_SELECTOR);
    if (!button) return;

    var form = button.closest('form');
    if (!form) return;

    var input = form.querySelector('input[name="upsell_variants"]');
    if (!input || !input.value) return;

    var upsellItems;
    try {
      var parsed = JSON.parse(input.value);
      if (!Array.isArray(parsed) || parsed.length === 0) return;

      var valid = parsed.every(function (item) {
        return item && typeof item.id === 'number' && typeof item.quantity === 'number';
      });
      if (!valid) return;

      upsellItems = parsed;
    } catch (_) {
      return;
    }

    // Upsell items found -- take full control of the event
    e.preventDefault();
    e.stopPropagation();

    // Read main variant from form
    var formData = new FormData(form);
    var mainId = Number(formData.get('id'));
    if (!mainId) return;

    // Build combined items (deduplicated)
    var itemsMap = {};
    itemsMap[mainId] = { id: mainId, quantity: 1 };

    upsellItems.forEach(function (u) {
      var id = Number(u.id);
      var qty = Number(u.quantity) || 1;
      if (!id || qty <= 0) return;
      if (itemsMap[id]) {
        itemsMap[id].quantity += qty;
      } else {
        itemsMap[id] = { id: id, quantity: qty };
      }
    });

    var items = Object.keys(itemsMap).map(function (k) { return itemsMap[k]; });

    // Show loading spinner on button
    button.setAttribute('aria-busy', 'true');

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Cart add failed: ' + r.status);
        return r.json();
      })
      .then(function () {
        var app = window.cartApp;
        if (!app) return;

        // Open and refresh the SectionHunt cart drawer.
        // openCart() toggles cartOpen, so only call it if closed.
        // updateCart() (called by openCart) fetches /cart.js and re-renders.
        if (!app.cartOpen) {
          app.openCart();
        } else {
          app.updateCart();
        }

        // Dispatch cart:change for the theme's <cart-count> header element.
        // We defer this to avoid a redundant /cart.js fetch (updateCart already
        // fetches it). Instead we read cartApp.cart once updateCart has settled.
        setTimeout(function () {
          var cart = app.cart;
          if (!cart) return;
          document.dispatchEvent(new CustomEvent('cart:change', {
            bubbles: true,
            detail: { baseEvent: 'variant:add', cart: cart }
          }));
        }, 2000);
      })
      .catch(function (err) {
        console.error('[Upsell] addToCart error:', err);
      })
      .finally(function () {
        button.removeAttribute('aria-busy');
      });
  }, true); // capture phase
})();
